import { Box, Table, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { HeaderData } from 'modules/finance/components/FinancialWorkspace/types/table'

import { stickyColumnProps } from '../../const'
import { STICKY_CELL_WIDTH } from '../Row/const'
import { HeaderCell } from './Cell'

interface Props {
  title: string
  isGrouped: boolean
  totalCount: number
  headers: string[] | HeaderData[]
}

export const RegularHeader = ({ headers, title, totalCount, isGrouped }: Props) => {
  return (
    <Table.Row>
      <Table.HeadCell sticky={stickyColumnProps} style={{ minWidth: STICKY_CELL_WIDTH }}>
        <Text size="200" color="grey800" weight="medium">
          {title}
          {isGrouped && totalCount > 1 && <>&nbsp;·&nbsp;</>}
        </Text>
        {isGrouped && (
          <Box paddingTop="s2">
            <Text size="100" color="grey800" weight="medium">
              {i18n.t('finance.financial_workspace.breakdown_table.items_count', {
                count: totalCount,
              })}
            </Text>
          </Box>
        )}
      </Table.HeadCell>

      {headers.map((header, index) => {
        return <HeaderCell header={header} key={index} />
      })}
    </Table.Row>
  )
}
